import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";

const StyledOutOfStock = styled.div`
  position: relative;
  max-width: 416px;
  padding: 24px 32px 32px;
  background: ${({ theme }) => theme.colors.tone.white};

  .OutOfStock__close {
    position: absolute;
    right: 24px;
    top: 28px;
    width: 24px;
    height: 24px;
    padding: 0;

    fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
  }

  .OutOfStock__close:hover {
    fill: ${({ theme }) => theme.colors.tone.anthraciteDark};
  }

  .OutOfStock__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  }

  .OutOfStock__text {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-width: 100%;
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.space[4]}px;
  width: 218px;
`;

export { StyledOutOfStock, StyledButton };
